import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { BookSVG } from '../svg/book.svg';

const BookIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <BookSVG/>
    </div>
  );
};

export { BookIcon };
